import { minutes, Time } from '@execonline-inc/time';
import { just, Maybe, nothing } from 'maybeasy';
import { action, computed, makeObservable, observable } from 'mobx';
import { error } from '../ErrorHandling';
import { errorAlert, FlashAlert } from '../Notifications/Types';
import { TPlainTextKey } from '../Translations';
import { BreakoutTimerState, ready, reset, updating, waiting } from './Types';

class BreakoutTimerStore {
  @observable
  state: BreakoutTimerState;

  constructor() {
    makeObservable(this);

    this.state = waiting();
  }

  @action
  error = (msg: TPlainTextKey) => {
    this.state = error(msg);
  };

  @action
  setDuration = (duration: Time) => {
    switch (this.state.kind) {
      case 'updating':
      case 'ready':
        this.state.duration = duration;
        break;
      case 'waiting':
      case 'error':
        break;
    }
  };

  @action
  ready = () => {
    switch (this.state.kind) {
      case 'waiting':
      case 'error':
        this.state = ready(minutes(20));
        break;
      case 'ready':
      case 'updating':
        this.state = ready(this.state.duration);
        break;
    }
  };

  @action
  reset = () => {
    this.state = reset();
  };

  @action
  updating = () => {
    switch (this.state.kind) {
      case 'ready':
        this.state = updating(this.state.duration);
        break;
      case 'updating':
      case 'waiting':
      case 'error':
        break;
    }
  };

  @computed
  get notification(): Maybe<FlashAlert> {
    switch (this.state.kind) {
      case 'error':
        return just(errorAlert(this.state));
      case 'ready':
      case 'updating':
      case 'waiting':
        return nothing();
    }
  }

  @computed
  get duration(): Maybe<Time> {
    switch (this.state.kind) {
      case 'ready':
      case 'updating':
        return just(this.state.duration);
      case 'waiting':
      case 'error':
        return nothing();
    }
  }
}

export default BreakoutTimerStore;
